<template>
  <v-app class="mouse-cursor">
    <nav-bar />

    <left-nav-bar v-if="isAuthenticated" />

    <v-main class="bg">
      <transition name="fade">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import NavBar from "./app/core-module/components/NavBar";
import LeftNavBar from "./app/core-module/components/LeftNavBar";

import {
  saveLanguage,
  setLanguage,
} from "./app/core-module/util/languageHelper";
import { initAuthHelper, saveUser } from "./app/user-module/helpers/authHelper";

export default {
  name: "App",
  components: { NavBar, LeftNavBar },
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
  },
  apollo: {
    getAppData() {
      return {
        query: require("./app/core-module/api/query/getAppData.gql"),
        result({ data, loading }) {
          if (data && data.getAppData) {
            if (data.getAppData.appSettings) {
              if (
                data.getAppData.appSettings.supportedCurrencies &&
                data.getAppData.appSettings.supportedCurrencies.length
              ) {
                this.$store.commit(
                  "SET_SUPPORTED_CURRENCIES",
                  data.getAppData.appSettings.supportedCurrencies
                );
              }

              if (
                data.getAppData.appSettings.currencyTable &&
                data.getAppData.appSettings.currencyTable.items
              ) {
                this.$store.commit(
                  "SET_CURRENCY_TABLE",
                  data.getAppData.appSettings.currencyTable
                );
              }
            }

            if (data.getAppData.user) {
              saveUser(data.getAppData.user);
            }

            if (data.getAppData.subscriptionInfo) {
              this.$store.commit(
                "SET_SUBSCRIPTION_INFO",
                data.getAppData.subscriptionInfo
              );
            }
          }
        },
      };
    },
  },
  created() {
    initAuthHelper();

    this.$vuetify.theme.dark =
      this.readFromLocalStorage("ThemeMode") === "dark";
  },
  watch: {
    "$route.params.lang": {
      handler: function (newValue) {
        if (newValue != null) {
          setLanguage(newValue, false);
          saveLanguage(newValue);
          this.$vuetify.rtl = newValue === "ar";
        }
      },
    },
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.no-background-hover::before {
  background-color: transparent !important;
}
</style>
